<template>
  <v-container fluid grid-list-xs class="pt-2">
    <v-card :flat="hideSave">
      <v-card-text>
        <v-layout row wrap>
          <v-flex
            sm4
            v-for="customField in sortedCustomFields"
            :key="customField.typeId"
            class="pr-3"
          >
            <v-text-field
              :label="customField.name"
              @change="onChange($event, customField)"
              :value="customField.content"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-layout justify-space-around pt-3 v-if="!hideSave">
      <save-btn @click="onSave" />
    </v-layout>
    <v-row v-if="debug">
      <v-col>
        <code>{{ value }}{{ customFieldsInput }}{{ customFields }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SaveBtn from "../shared/SaveButton";
export default {
  name: "CustomFieldsForm",

  props: {
    customFieldsInput: {
      type: Array,
      default: () => [],
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    hideSave: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    SaveBtn,
  },

  data() {
    return {
      debug: false,
      customFields:
        this.customFieldsInput && this.customFieldsInput.length > 0
          ? [...this.customFieldsInput]
          : this.value && this.value.length > 0
          ? [...this.value]
          : [],
    };
  },

  methods: {
    onChange($event, customField) {
      const updatedItem = {
        name: customField.name,
        typeId: customField.typeId,
        content: $event,
      };
      const newUpdatedList = [
        ...this.sortedCustomFields.filter(
          (cf) => cf.typeId != updatedItem.typeId
        ),
        updatedItem,
      ];
      this.$emit("onCustomFieldsChange", newUpdatedList);
      this.$emit("input", newUpdatedList);
    },
    onSave() {
      this.$emit("onSave");
    },
  },
  watch: {
    value(newVal) {
      this.customFields = [...newVal];
    },
  },
  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    sortedCustomFields() {
      return [
        ...this.customFields.sort((a, b) => a.name.localeCompare(b.name)),
      ];
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/CustomFieldsForm.vue